// The platform's transport for Customize mode (packages/page-runtime/src/
// customize): the /livepreview/model-overlay/* endpoints, bound to one
// project. What a tenant may change is decided by the server's overlay
// policy; where it is stored (the caller's tenant database) too.

import { useEffect, useState } from 'react'
import type { CustomizeTransport } from '@twasta/page-runtime/customize'
import {
  modelOverlayCanCustomize, modelOverlayGet, modelOverlayPatch, modelOverlayReset,
} from '@/livepreview/api'

export function platformCustomizeTransport(project: string): CustomizeTransport {
  return {
    get: (objType, objName) => modelOverlayGet(project, objName, objType),
    patch: (objType, objName, set, reset) => modelOverlayPatch(project, objName, set, reset, objType),
    reset: (objType, objName) => modelOverlayReset(project, objName, objType),
  }
}

/** Whether the caller may customize this application's screens for their
 *  organization — drives the ⋮ "Customize" entry. `enabled=false` skips the
 *  request (e.g. a designer surface). */
export function useCanCustomize(project: string, enabled = true): boolean {
  const [can, setCan] = useState(false)
  useEffect(() => {
    if (!enabled || !project) { setCan(false); return undefined }
    let cancelled = false
    modelOverlayCanCustomize(project, 'T').then((v) => { if (!cancelled) setCan(v) })
    return () => { cancelled = true }
  }, [project, enabled])
  return can
}
